

exports.__esModule = true;
exports.$ul = undefined;

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _config = require('squid/dist/core/config');

var _model = require('xo-tracking/dist/model');

var _auth = require('xo-models/src/auth');

var $ul = exports.$ul = {

    optInToOneTouch: function optInToOneTouch(token, locale_country, locale_code, silent, fptiData, flowName) {

        return (0, _angular.$q)(function (resolve, reject) {

            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 10000;
            var ulTimeoutPromise = null;

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData && fptiData.stateName ? fptiData.stateName : 'poma_page',
                    'to': fptiData && fptiData.transInfix ? fptiData.transInfix : 'process_kmli_optin'
                };
                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            function failureHandler(reason) {
                logSubmit({ errorCode: reason });
                _logger.$logger.info('UL_Loading_error_' + reason);
                return reject(new Error('UL_Loading_error_' + reason));
            }

            function startTimer(tag) {
                _logger.$logger.info('UL_START_TIMER_' + tag);
                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    failureHandler('timed_out');
                    if (!silent) {
                        _angular.$rootScope.$emit('loaded');
                    }
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                if (!silent) {
                    _angular.$rootScope.$emit('loaded');
                }
                _logger.$logger.info('UL_STOP_TIMER_' + tag);

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                    ulTimeoutPromise = null;
                }
            }

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    logSubmit();
                    // UL will drop RT cookie and respond oneTouchInterstitialOptInSuccess postmessage.
                    _auth.$AuthModel.instance().retrieve().then(function (auth) {
                        auth.refresh_token = true;
                    });
                    return resolve();
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    failureHandler(data.event);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    // removing the element - ulTargetAttribute from DOM, to avoid any other accidental
                    // actions on the element which is causing excess spinners later.
                    var child = document.getElementById('ulTargetAttribute');
                    child.parentNode.removeChild(child);
                    stopTimer(data.event);
                    failureHandler(data.event);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;
                    if (eventId) {
                        _logger.$logger.debug('UL' + eventId, response);
                        var handler = ulEventHandlers[eventId];
                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function loadOneTouchUpsell() {
                if (!silent) {
                    _angular.$rootScope.$emit('loading');
                }

                var ulTargetAttribute = document.createElement('div');
                ulTargetAttribute.setAttribute('id', 'ulTargetAttribute');

                // setting display to None leading FireFox hiding all the ul elements due to which body click doesn't work
                // ulTargetAttribute.style.display = "None";

                // Making 0px, it works for FF, Chrome, Safari
                ulTargetAttribute.style.width = '0px';
                ulTargetAttribute.style.margin = '0px';
                ulTargetAttribute.style.height = '0px';
                ulTargetAttribute.style.padding = '0px';

                document.body.appendChild(ulTargetAttribute);

                var options = {
                    targetElement: document.getElementById('ulTargetAttribute'),
                    queryParams: {
                        'country.x': locale_country,
                        'locale.x': locale_code,
                        'flowId': token,
                        'correlationId': _model.$CalDataModel.getCalCorrId(),
                        'flowName': flowName ? flowName : 'checkoutOnlyMember' // default is poma flow
                    },
                    iframePathname: '/signin/activate-one-touch',
                    onPostMessage: postMessageHandler
                };

                if (_config.$config.deploy.isLocal()) {
                    if (_config.$meta.stage) {
                        options.origin = 'https://' + _config.$meta.stage;
                    } else {
                        // if no stage url shows up then use any backup url for origin
                        options.origin = _config.$config.onboarding.url.split('/webapps/')[0];
                    }
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    startTimer('initializeUl');
                    PAYPAL.unifiedLogin.inject(options);
                } else {
                    failureHandler('PAYPAL.unifiedLogin_undefined');
                }
            }

            loadOneTouchUpsell();
        });
    }
}; /**
    * Created by upigilam on 4/8/16.
    * UL handler is to exchange ST to RT exchanges.
    */

angular.value("$ul", $ul);
_angular.$rootScope;

_angular.$q;

_angular.$timeout;

_logger.$logger;

_config.$config;

_config.$meta;

_model.$CalDataModel;

_auth.$AuthModel;


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/unified-login/ul.js
// module id = ./components/xo-login-components/src/unified-login/ul.js
// module chunks = 1